import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { CategoriaCnhApiService } from "./categorias-cnh/shared/categoria-cnh-api.service";

@NgModule({
  imports: [
    SharedModule
  ],
  providers:[
    CategoriaCnhApiService
  ],
  declarations: []
})
export class CnhModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/cnh/cnh.module.ts
 **/